import { BaseMobileService } from './base-mobile.service';
import androidPermissionsService from './android-permissions.service';
import { NotificationType, eModuleTypes, RouterView } from '@/models/enums';
import router from '@/router/router';
import { logger } from '@/helpers/log.service';
import { EventBus } from '@/helpers/event-bus';
import { isNativeAndroid, isNativeIos } from '@/helpers/platform-helper';

const appCreatedPromise = new Promise(resolve => EventBus.$on('app-created', resolve));

class PushNotificationService extends BaseMobileService {
  constructor() {
    super('FirebasePlugin', 'PushNotificationService');
  }

  public getDeviceToken(): Promise<string> {
    return this.execute('getToken') as Promise<string>;
  }

  public grantPermissionIos(): Promise<string> {
    return this.execute('grantPermission') as Promise<string>;
  }

  public hasPermissionIos(): Promise<string> {
    return this.execute('hasPermission') as Promise<string>;
  }

  public async init(): Promise<void> {
    if (isNativeIos()) {
      const permissionsGranted = await this.hasPermissionIos();
      logger.debug(`[cordova.ts] permissionsGranted=${permissionsGranted}`);
      if (!permissionsGranted) {
        await this.grantPermissionIos();
      }
    } else if (isNativeAndroid()) {
      await androidPermissionsService.requestNotificationPermission();
    }

    await this.execute(
      'onMessageReceived',
      null,
      null,
      null,
      onMessageReceived,
      (err) => {
        logger.error('[PushNotificationService.onMessageReceived] error', err);
      });
  }
}

function onMessageReceived(message) {
  try {
    logger.debug('[PushNotificationService.onMessageReceived]', message);

    if (message.pushNotificationType && message.tap === 'background') {
      switch (message.pushNotificationType) {
        case NotificationType[NotificationType.UserGotDocument]:
          handleDocumentNotification(message.documentVersionCode, eModuleTypes.DocumentsIn);
          break;
        case NotificationType[NotificationType.AuthorGotDecision]:
          handleDocumentNotification(message.documentVersionCode, eModuleTypes.DocumentsOut);
          break;
        case NotificationType[NotificationType.DocumentGotNewComment]:
          handleDocumentNotification(message.documentVersionCode, eModuleTypes.DocumentsAll);
          break;
        case NotificationType[NotificationType.UserGotInvitation]:
          if (router.currentRoute.name !== RouterView.Invitations) {
            router.push({ name: RouterView.Invitations });
          }
          break;
        default:
          break;
      }
    }
  } catch (err) {
    logger.error('[PushNotificationService.onMessageReceived] callback error: ', err);
  }
}

async function handleDocumentNotification(docverode: string, moduleType: eModuleTypes) {
  if (
    router.currentRoute.name !== 'viewdoc' ||
    router.currentRoute.params.docverode !== docverode
  ) {
    await appCreatedPromise;
    router.push({
      name: 'viewdoc',
      params: { moduleType: moduleType.toString(), docverode, folderId: '0' }
    });
  }
}

export default new PushNotificationService();
